module.exports = __webpack_public_path__ + "img/fixed.b95b7ac9.jpg";